<h2 class="mat-title">Aktivierungsschlüssel für diesen Benutzer</h2>

<ng-container *ngIf="activations; else noActivations">
  <table class="activations-table">
    <thead>
    <tr>
      <th>ID</th>
      <th>Typ</th>
      <th>Schlüssel</th>
      <th>Verwendet</th>
      <th>Erstellt</th>
      <th>Aktualisiert</th>
      <th>Gültig bis</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let activation of activations">
      <td>{{activation.id}}</td>
      <td>{{activation.type}}</td>
      <td>{{activation.key}}</td>
      <td>{{activation.used ? 'Ja' : 'Nein'}}</td>
      <td>{{activation.entry | date:'short'}}</td>
      <td>{{activation.upd | date:'short'}}</td>
      <td>
        {{activation.expires | date:'short'}}
      </td>
      <td class="expiry">
        <ng-container *ngIf="!activation.used && activation.valid">
          <span (click)="extendActivation(activation)"
                matTooltip="Verlängerung: heute + 14 Tage"
                class="extend"><mat-icon>more_time</mat-icon></span>
        </ng-container>
      </td>
    </tr>
    </tbody>
  </table>
</ng-container>

<ng-template #noActivations>
  <p>Keine Benutzeraktivitäten gefunden</p>
</ng-template>

<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close] mat-button>Schließen</button>
</div>
